import React from 'react'
import classNames from 'classnames'
import { queryTypeList, QUERY_TYPE_VALUE } from '../enum'
import './index.less'

export default ({ value, onChange, data, option = queryTypeList }) => {
  return <div className="mn-ins-tab-wrap">
    {option.map((v, i) => (<div
      key={i}
      className={classNames('tab-item', { active: value === v.value })}
      onClick={() => onChange(v.value)}
    >
      {v.label}
      {v.value === QUERY_TYPE_VALUE.collected && <span>&nbsp;{data?.[0]?.currentCollectNum}</span> }
    </div>))}
  </div>
}
